<template>
  <div class="page">
    <div class="main">
      <img src="@/assets/img/mobile.png" alt="" class="mobile" />
      <div class="login">欢迎登录您的账号，开启全新体验</div>
      <div class="ph-input">
        <img src="@/assets/img/phone-img.png" alt="" class="phone" />
        <van-field v-model="userPhone" type="tel" clear-trigger="always" class="ph-t" clearable placeholder="输入收件11位手机号码" />
      </div>
      <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">登录</van-button>
      <div class="d-checked">
        <van-checkbox v-model="checked" shape="square" icon-size="16px">我已阅读并同意</van-checkbox><span @click="cccc()"
      style="color: #3382fe;">《流量卡用户隐私政策》</span>
      </div>
    </div>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
import mixins from '@/mixins/mixins.js'
export default {
  components: {
  },
  data() {
    return {
      userPhone: null,
      checked: true,
      code: ''

    }
  },
  mixins: [mixins],
  mounted() {

  },
  async created() {
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    var appid = "wxb4bff16244869bed";
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
       window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
    } else {
      var search = window.location.search;
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
 
      localStorage.setItem('newCode', this.code);
      var newUserPhone = localStorage.getItem('userPhone'); //newUserPhone
      var newLoginText = localStorage.getItem('recordLoginText');//newLoginText
      if (this.$route.query.newCardNo) {
        newLoginText = this.$route.query.newCardNo;
      }
      if (newUserPhone && newUserPhone.length > 5 && newLoginText && newLoginText.length > 2) {
        //直接到登录页面
         this.nextClick(newLoginText,newUserPhone,this.code,0,1);
       // this.$router.push({ path: "/newUser/bindNew/bindingCard", query: { userPhone: newUserPhone, newLoginText: newLoginText } })
      }


    }

  },
  methods: {
    onSubmit() {
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast('请填写正确的手机号')
        return
      }
      if (!this.checked) {
        Toast('请阅读并同意隐私政策')
        return
      }
      if (!this.code) {
        Toast('授权失败，请重新扫码登录')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code === '200') {
          Toast.success('验证码已发送，请查收（请在有效期内验证）')
          this.$router.push({ path: "/newUser/bindNew/getCode", query: { userPhone: this.userPhone, code: this.code } })
        } else {
          Toast.fail(res.data.message)
        }
      })
    },



    cccc() {
      Dialog.confirm({
        title: '小象通信用户隐私政策',
        width: '90%',
        showCancelButton: false,
        messageAlign: 'left',
        confirmButtonColor: '#ee0a24',
        message: `尊敬的客户：
        我们致力于为用户提供全网更具性价比的通信产品服务（以下均简称为“我们的产品或/和服务”）。

我们非常重视用户的隐私和个人信息保护，致力于维持您对我们的信任。我们承诺采取相应的安全保护措施来保护您的个人信息。请在使用我们的物联网服务、移动业务、宽带业务等各项产品或服务（以下统称“我们的产品或服务”）前，仔细阅读并了解《万卡通讯用户隐私政策》（以下简称“本隐私政策”）。

您在使用我们的产品或服务时，我们将按照《中华人民共和国个人信息保护法》等国家法律法规及监管政策的相关要求处理您的个人信息，以及向您提供服务，我们希望通过本隐私政策向您说明：在您使用我们的产品或服务时，我们会收集哪些数据、为什么收集这些数据、会利用这些数据做什么以及我们如何保护这些数据。

本平台尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本平台会按照本隐私权政策的规定使用和披露您的个人信息。但本平台将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本平台不会将这些信息对外披露或向第三方提供。本平台会不时更新本隐私权政策。 您在同意本平台用户服务使用使用协议之时，
即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本平台用户服务协议不可分割的一部分。本政策适用于我们为您提供的上述产品和服务。

阅读过程中，如您对我们的隐私政策及服务条款的内容有任何疑问，请联系我们。如您点击确认本隐私政策，即表示您已经阅读并同意本隐私政策全部内容。本隐私政策包含以下内容：

1.	我们如何收集和使用您的个人信息；
2.	我们如何使用 Cookie 和同类技术；
3.	我们如何共享、转移、公开披露您的个人信息；
4.	我们如何保护您的个人信息；
5.	我们如何处理未成年人的个人信息；
6.	您的个人信息如何存储及在全球范围转移；
7.	本隐私政策如何更新；
8.	您的权利；
9.	如何联系我们。

一、我们如何收集和使用您的个人信息

个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。

（一）为更好地为您提供服务，我们将遵循“合法、正当、必要和诚信”原则，按照相关法律法规及监管政策的规定收集和使用如下您的个人信息：

1.用户登记的个人身份信息

根据《中华人民共和国网络安全法》《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等规定，您在办理激活开户手续时须向我们出示有效证件、提供真实身份信息；留存的个人信息主要包括：个人身份及网络身份标识鉴权信息[主要包括个人用户姓名、有效通信联系方式、有效证件类型及号码、证件登记信息、装机地址、交费账号、电子邮箱、拍照或在线视频方式获得的影像资料、服务账号及密码、密码保护答案、办理的业务]。如您拒绝提供个人有效证件及真实信息，将无法办理激活开户手续，无法使用我们的产品或服务。

2、使用服务过程中产生的信息

您使用我们提供的服务时，我们可能自动收集以下信息：

（1）日志信息

指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括：

A.设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码。

B.您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息。

C.实现服务所必须的基本信息，例如为实现接通您的通话网络所必需的对方号码。

（2）位置信息

指您开启设备定位功能或使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过IP地址、GPS、基站、Wi-Fi等方式收集的您的地理位置信息。

（3）手机账户信息

指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号等相关信息。

3.为共同向您提供产品服务或改进产品服务的质量或出于对产品服务安全性的考量等合理需要，我们可能按照相关法律法规及监管政策的要求或经过您的授权从关联公司、合作伙伴及其他受信任的第三方接收您的个人信息及其他信息。例如当您通过我们关联公司、业务合作伙伴网站订购我们的产品，您向其提供的预订信息可能会转交给我们，以便我们处理您的订单。

4.在收集过程中，我们将严格遵守相关法律法规及监管政策，不收集任何法律法规及监管政策禁止收集的信息。

5.您了解并同意，以下情形中我们使用个人信息无需征得您的授权同意：

（1）为订立、履行与您的合同所必需；

（2）为履行法定职责或者法定义务所必需；

（3）为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；

（4）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；

（5）与国家安全、国防安全有关的；

（6）与公共安全、重大公共利益有关的；

（7）与犯罪侦查、起诉、审判和判决执行等有关的；

（8）用于维护所提供的产品或服务的安全稳定运行所必需，例如发现、处置产品或服务的故障；

（9）法律法规及监管政策规定的其他情形。

（二）为向您提供服务，在遵守国家法律法规及监管政策的前提下，我们可能将收集到的您的个人信息用于以下目的：

1.为您提供服务

（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；

（2）根据国家相关要求，用于旨在推进政府管理、加强社会治理、改善社会民生、建立诚信体系等目的的服务；

（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个人需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户做出其他方面的回应；

（4）评估我们的服务效果，并加以改善；

（5）软件认证或管理软件升级；

（6）邀请您参与有关我们产品和服务的调查。

2.您了解并同意，我们可以通过技术手段对您的个人信息数据进行匿名化处理，匿名化处理的信息将无法识别个人主体。在此情况下我们有权使用已经匿名化的信息，并在符合相关法律法规及监管政策的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。

3.当我们要将信息用于本隐私政策未载明的其它用途时，会事先征求您的同意。

二、我们如何使用 Cookie 和同类技术

（一）Cookie

为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或购物篮内的商品等数据。

我们不会将Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。

（二）网站信标和像素标签

除Cookie外，我们还有可能会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。

（三）Do Not Track（请勿追踪）

很多网络浏览器均设有“Do Not Track”（请勿追踪）功能，该功能可向网站发布“Do Not Track”请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了“Do Not Track”，那么我们的所有网站都会尊重您的选择。

三、我们如何共享、转移和公开披露个人信息

（一）共享

我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：

1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。

2.我们可能会根据法律法规及监管政策要求，或按政府主管部门的强制性要求，对外共享您的个人信息。

3.与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们将依照合法、正当、必要、诚信原则，仅出于在能够实现业务目的最小范围内共享您必要的个人信息，且受本隐私政策所声明目的的约束。如相关法律法规、监管政策要求或我们为维护您的权益认为确有必要时，我们亦会在将信息提供给关联公司前征得您的单独同意。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。

我们的关联公司包括本公司现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。

4.与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供，为此我们可能会与合作伙伴共享您的某些个人信息。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们将依照合法、正当、必要、诚信原则，仅出于在能够实现业务目的最小范围内共享您必要的个人信息。如相关法律法规、监管政策要求或我们为维护您的权益认为确有必要时，我们亦会在将信息提供给授权合作伙伴前征得您的单独同意。我们的合作伙伴无权将共享的个人信息用于任何其他用途。

目前，我们的授权合作伙伴包括以下3大类型：

（1）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利、交易安全服务或进行学术研究和调查。

（2）第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。

（3）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会共享用于识别您个人身份的信息，我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以提升广告及服务信息的有效触达率。对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、隐私政策以及其他任何相关的保密和安全措施来处理个人信息。

（二）转移

我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：

1.在获取明确同意的情况下转移：获得您的明确同意后，我们会向其他方转移您的个人信息；

2.在涉及合并、收购或破产清算时，如涉及到个人信息转移，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意；

3. 相关法律法规规定或我们与您约定的其他情形。

（三）公开披露

我们仅会在以下情况下，公开披露您的个人信息：

1.获得您明确同意后；

2.基于法律的披露：在法律法规、法律程序或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。

四、我们如何保护您的个人信息

（一）我们承诺将严格按照国家有关规定做好用户个人信息安全防护工作。我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们将采取一切合理可行的措施，（例如身份鉴别、信息收集监测和审计、网络专线传输、防入侵、防病毒、信息加密存储、信息访问的权限管理、信息认证授权和监控审计、信息脱敏、信息溯源等）以及配套的管理体系来保护您的个人信息。同时我们已设立用户信息保护责任部门，建立相关内控制度，对可能接触到您信息的工作人员采取最小够用授权原则；对工作人员进行相关法律法规、隐私政策和安全意识培训，对工作人员处理您的信息的行为进行系统监控。我们并将接受国家相关机构的信息安全检查。

（二）您需要承诺妥善保存登录的账号、密码等信息，由于您的原因造成账号密码的泄露产生的后果由您承担。为防止信息泄露，我们将采取防泄漏等技术手段，限制频繁查询您的信息等异常操作行为，以防止账号密码泄露或他人冒用身份造成您产生不良行为记录或者您的信息泄露。

（三）我们已制定个人信息安全事件应急预案，提高应急处理能力。但由于技术水平限制及可能存在的各种恶意手段，有可能因我们可控范围外的因素而出现安全问题。在发生个人信息安全事件后，我们将按照相关法律法规及监管政策的要求，及时向您告知：安全事件的基本情况和可能影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。

五、我们如何处理未成年人的个人信息

（一）我们非常重视对未成年人个人信息的保护。我们将根据国家相关法律法规及监管政策的规定保护未成年人的个人信息。

（二）如您为不满十八周岁的未成年人，在使用我们的服务前，应在您的父母或其他监护人监护、指导下共同阅读本隐私政策，并由您的父母或其他监护人确认是否同意本隐私政策。

（三）对于经父母或其他监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。

（四）如您是未成年人的父母或其他监护人，请您关注您监护的未成年人是否在取得您的授权同意之后使用我们的服务。如您对您所监护的未成年人的个人信息有疑问，请通过本隐私政策中的联系方式与我们联系。

（五）如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。

六、您的个人信息如何存储及在全球范围转移

我们在中华人民共和国境内收集的个人信息，将存储在中华人民共和国境内。我们仅在本隐私政策所述目的所必需期间和法律法规及监管规定的时限内保留您的个人信息。如果需要将您的个人信息转移到境外，我们将：

（一）另行获得您的授权同意，并履行法定程序，在符合届时适用法律的情形下使您的个人信息得到足够的保护；

（二）该等转移将在符合届时适用法律要求的前提下进行，即便获得您的授权但如果转移方式或者目的不符合相关法律法规规定的，我们也不会进行转移。

七、本隐私政策如何更新

我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。基于为给您提供更好的服务以及随着电信业务的发展或法律法规及监管政策变化，我们可能会适时对本隐私政策进行更新。由于我们的用户较多，如本隐私政策发生重大变更，我们将以推送通知、发送邮件、信函、电话或者网站发布公告的方式来通知您。若您在本隐私政策修订后继续使用我们的产品或服务，这表示您已充分阅读、理解并愿意接受修订后的本隐私政策约束。

八、您的权利

（一）访问您的个人信息

您有权访问您的个人信息，法律法规规定的例外情形除外。

（二）更正您的个人信息

当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过访问您的个人信息中罗列的方式提出更正申请。

（三）删除您的个人信息

在以下情形中，您可以向我们提出删除个人信息的请求：

1.如果我们处理个人信息的行为违反法律法规；

2.如果我们收集、使用您的个人信息，却未征得您的同意；

3.如果我们处理个人信息的行为违反了与您的约定；

4.如果您不再使用我们的产品或服务，或您注销了账号；

5.如果我们不再为您提供产品或服务。

请您注意，当您或我们协助您成功删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，之前的信息我们仍会按照监管政策要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询，保存期间我们会安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以删除或实现匿名化。

（四）改变您授权同意的范围

每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以使用多种方式设置（如历史记录设置等）来关闭部分功能选项从而撤销部分授权。当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理活动的效力。

（五）响应您的上述请求

为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的要求。对于您关于用户个人信息的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。在以下情形中，按照法律法规及监管政策要求，我们将无法响应您的请求：

1.与国家安全、国防安全直接相关的；

2.与公共安全、公共卫生、重大公共利益直接相关的；

3.与犯罪侦查、起诉、审判和判决执行等直接相关的；

4.有充分证据表明您存在主观恶意或滥用权利的；

5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；

6.涉及商业秘密的。

九、如何联系我们

公司名称：武汉万卡通讯有限公司
相关负责人邮箱：kf@wankatong.com.cn

如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，可以拨打400-093-9989客服热线联系我们，一般情况下，我们将在十五个工作日内回复。

本版更新日期：2023年5月13日


关于客户个人信息收集、使用规则的公告

尊敬的客户：
《全国人民代表大会常务委员会关于加强网络信息保护的决定》、  《电信和互联网用户个人信息保护规定(工业和信息化部令第24号)和《电话用户真实身份信息登记规定》  (工业和信息化部令第25号)等国家法律法规的要求，客户在运营商各类营业网点(含自有营业厅、手机营业厅、网上营业厅、授权合作代理商等)办理固定电话、移动电话(含无线上网卡)入网、过户以及需要出示客户证件的有关业务时，客户应配合出示有效证件原件并进行查验、登记，登记信息包括姓名、证件类型、号码及地址等。同时，为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。客户本人持有效证件可通过自有营业厅查询和/或更正本人信息，或登录手机营业厅查询本人信息。
如客户拒绝依法提供个人有效证件及真实信息，我公司有权不提供服务或终止服务。
为向客户提供优质、个性化的服务，包括但不限于提供通信服务、保障通信服务安全、改善服务质量、推介个性化产品等，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客户个人信息，并妥善保管，严格保密，依法保护客户个人信息，
非因下列事由，不对外泄露客户个人信息：
(a)事先获得客户的明确授权；
(b)根据有关的法律法规要求；
(c)按照相关司法机关和/或政府主管部门的要求；
(d)为维护社会公众的利益所必需且适当；
(e)为维护我公司或客户的合法权益所必需且适当。


单独同意书

本人向贵司(武汉万卡通讯有限公司)申请提供精选靓号、话费、流量、宽带、影视会员VIP折扣等通信产品服务，鉴于贵司在业务审查、审批或者其他业务过程需要收集及使用本人信息，本人已充分知悉并明确同意：
鉴于贵司为本人提供前述服务，本人同意，贵司有权向本人所选购通信产品对应的合作运营商(以下称为“信息接收方”)提供并处理贵司基于《用户隐私政策》所收集的本人下单时提交的个人信息，且本人确认贵司已向本人充分告知、本人也明确知悉信息接收方及信息处理的情况如下：
1、中国移动通信集团有限公司及其子公司、分公司
联系方式：10086
2、中国联合网络通信集团有限公司及其子公司、分公司
联系方式：10010
3、中国电信集团有限公司及其子公司、分公司
联系方式：10000
4、中国广播电视网络有限公司及其子公司、分公司
联系方式：10099
处理目的：向运营商提交个人实名认证所需信息或同步用户下单提交的信息，由运营商提供后续产品服务；
处理方式：个人实名认证或订单信息回传
个人信息种类：个人基本信息(包括姓名、电话号码、身份证)
本人在此声明：
本人已充分理解上述条款的含义，充分了解该等信息处理活动依赖互联网开展而互联网环境并非绝对安全，本人仍作出上述同意。贵司已经对相关事宜与风险向本人进行充分披露及说明，本人已知晓并同意。本人承诺并保证，本人在本同意书项下所提供的所有本人信息真实、准确、完整、有效，且不会侵犯任何第三方的合法权利。






            `,
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },





  }
}
</script>
<style lang="less" scoped>
.page {
  background: #fff;
  height: 100%;

  .main {
    padding-top: 66px;
    flex: 1;
    display: flex;
    align-items: stretch;
    flex-direction: column;

    .mobile {
      margin-left: 27px;
      margin-bottom: 28px;
      width: 180px;
      height: 58px;
    }

    .login {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      letter-spacing: 1px;
      margin-left: 27px;
    }

    input {
      margin-right: 20px;
      width: 45px;
      text-align: center;
      border: none;
      border-bottom: 1px solid #212121;
      font-size: 24px;
      outline: none;
      background: none;
    }

    input:last-of-type {
      margin-right: 0;
    }

    input:disabled {
      color: #000;
      background-color: #fff;
    }

    .point {
      flex-direction: row;
      margin-top: 37px;
      justify-content: center;
      display: flex;
      font-size: 17px;
      color: #707070;
      margin-bottom: 36px;

      .once {
        color: #0c62ee;
      }
    }

    .ph-input {
      width: 90%;
      height: 49px;
      background: #fff;
      border-radius: 2px;
      background: #f3f7fe;
      margin: 72px auto 59px auto;
      display: flex;
      align-items: center;

      .phone {
        width: 12px;
        height: 17px;
        margin: 0 11px 0 19px;
      }

      .ph-text {
        color: #06121e;
        width: 50px;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
      }

      .ph-t {
        color: #06121e;
        flex: 1;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
        padding: 0;
        background: none;

        ::v-deep .van-field__left-icon {
          .van-icon {
            font-size: 22px;
          }
        }

        ::v-deep.van-cell__value {
          .van-field__control {
            background: none;
            padding-left: 14px;
            color: #000;

            &::-webkit-input-placeholder {
              color: #c0c4cc;
            }
          }
        }
      }
    }

    .van-checkbox {
      justify-content: center;
    }

    .bu_tn-a {
      width: 316px;
      height: 49px;
      border-radius: 30px;
      font-size: 19px;
      color: #fff;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      line-height: 49px;
      letter-spacing: 1px;
      text-align: center;
      background: #3483fe;
      margin: auto auto 30px auto;
    }
  }
  .d-checked{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

